import React from 'react';
import parse, { domToReact } from 'html-react-parser';

const parseTerms = (HTML) => {
    const options = {
        replace: (domNode) => {
            if (domNode.type === 'tag' && domNode.name === 'h1') {
                return React.createElement(
                    'h1',
                    {
                        style: { color: '#aaa', fontSize: '1.9rem', fontWeight: 400 },
                        className: domNode.attribs && domNode.attribs.class,
                    },
                    domToReact(domNode.children, options), // this causes that the children will also be parsed...
                );
            }

            if (domNode.type === 'tag' && domNode.name === 'h2') {
                return React.createElement(
                    'h2',
                    {
                        style: { fontSize: '1.2rem', fontWeight: 400 },
                        className: domNode.attribs && domNode.attribs.class,
                    },
                    domToReact(domNode.children, options), // this causes that the children will also be parsed...
                );
            }

            if (domNode.type === 'tag' && domNode.name === 'h3') {
                return React.createElement(
                    'h3',
                    {
                        style: { fontSize: '1rem', fontWeight: 400 },
                        className: domNode.attribs && domNode.attribs.class,
                    },
                    domToReact(domNode.children, options), // this causes that the children will also be parsed...
                );
            }

            if (domNode.type === 'tag' && domNode.name === 'h4') {
                return React.createElement(
                    'h4',
                    {
                        style: { fontSize: '0.9rem', fontWeight: 300 },
                        className: domNode.attribs && domNode.attribs.class,
                    },
                    domToReact(domNode.children, options), // this causes that the children will also be parsed...
                );
            }

            return undefined;
        },
    };

    return parse(HTML, options);
};

export default parseTerms;
